import { ReactNode } from 'react';

export function reactNodeToString(node?: ReactNode): string {
  if (!node) {
    return '';
  }
  if (typeof node === 'string') {
    return node;
  }
  if (typeof node === 'number' || typeof node === 'boolean') {
    return `${node}`;
  }
  let result: string;
  try {
    result = getTextFromComponent(node as ReactEl);
  } catch (e) {
    result = '';
  }
  return result;
}

type ReactEl = { props?: { children?: string | ReactEl | (string | ReactEl)[] } };

function getTextFromComponent(component: ReactEl): string {
  if (!Object.keys(component).length || !component.props?.children) {
    return '';
  }
  let result = '';
  const kids = Array.isArray(component.props?.children)
    ? [...(component.props?.children || [])]
    : [component.props?.children];
  while (kids.length) {
    const firstElem = kids.shift();
    if (typeof firstElem === 'string') {
      result += firstElem;
    } else if (Array.isArray(firstElem?.props?.children)) {
      kids.push(...(firstElem?.props?.children ?? []));
    } else if (firstElem?.props?.children) {
      kids.push(firstElem.props.children);
    }
  }

  return result;
}
